import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {INSTANT_BOOK__16} from '@homeaway/svg-defs';

export const InstantBookableSVG = ({svgTitle}) => {
    return (
        <span title={svgTitle} className="instantBookableSVG__tooltip">
            <SVGIcon markup={INSTANT_BOOK__16} />
        </span>
    );
};

export default InstantBookableSVG;
